import client from '../httpClient';

// 【mokuhyoMst001】キマリス目標一覧取得
const getKimarisTarget = () => {
  return client.get('/keymalis-target-settings/');
};

export default getKimarisTarget;
